import React, { Fragment, useEffect, useMemo } from 'react';
import Nav from '../components/Nav/Nav';
import { ArrowLeftOutlined, FormOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../App.css';

function Products() {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    listCategories,
    getCategories,
    getProducts,
    listProducts,
    currentRestaurant,
    currentUser,
    getRestaurant,
    getRestaurantOrders,
    ordersList,
  } = useAuth();

  const MyProducts = listProducts?.filter((product) => product.restaurant === id);

  useEffect(() => {
    getCategories(id);
    getProducts(id);
    getRestaurant(id);

    const unsubscribe = getRestaurantOrders(id);

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (
      currentUser &&
      currentRestaurant &&
      currentRestaurant.owner !== currentUser.uid
    ) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, currentRestaurant]);

  const productStats = useMemo(() => {
    const stats = {};

    const paidOrders = ordersList?.filter((order) =>
      ['paid', 'preparing', 'ready', 'out_for_delivery', 'delivered', 'completed'].includes(order.status)
    );

    paidOrders?.forEach((order) => {
      order.items?.forEach((item) => {
        const productId = item.productId;
        if (!productId) return;

        if (!stats[productId]) {
          stats[productId] = {
            salesCount: 0,
            revenue: 0,
          };
        }

        stats[productId].salesCount += Number(item.quantity || 0);
        stats[productId].revenue += Number(item.lineTotal || 0);
      });
    });

    return stats;
  }, [ordersList]);

  const formatAmount = (value) =>
    `${(Number(value || 0) / 100).toFixed(2)} €`;

  return (
    <div className="one-page">
      <Nav />

      <div className="main">
        <div className="wrapper-container">
          <div className="wrapper-content">
            <div className="title-wrapper">
              <div className="title-back">
                <ArrowLeftOutlined onClick={() => navigate(-1)} className="back" />
                <p>Produits {MyProducts?.length > 0 ? `(${MyProducts.length})` : ''}</p>
              </div>

              <button
                onClick={() => navigate(`/shop/${id}/products/new`)}
                className="button"
              >
                Ajouter un produit
              </button>
            </div>

            {MyProducts?.length < 1 && (
              <div className="not-found">
                <p>Aucun produit (commencez par ajouter une catégorie).</p>
              </div>
            )}

            <div className="wrapper">
              {MyProducts?.map((product, index) => {
                const stats = productStats[product.id] || {
                  salesCount: 0,
                  revenue: 0,
                };

                return (
                  <div key={product.id}>
                    <div
                      className={`card-item ${index === MyProducts.length - 1 ? '' : 'border'
                        }`}
                    >
                      <div className="title-wrap max-product">
                        <img
                          className={`profile ${!product.picture ? 'bg-grey' : ''}`}
                          src={product.picture}
                          alt=""
                        />

                        <div>
                          <p className="title">{product.name}</p>
                          <p className="sub-title sub-title-price">Prix : {product.price} €</p>
                          {currentRestaurant?.productType !== "digital" && (
                            <p className="sub-title">
                              Stock : {Number(product.quantity || 0)}
                            </p>
                          )}
                          <p className="sub-title">
                            Ventes : {stats.salesCount}
                          </p>
                          <p className="sub-title">
                            CA : {formatAmount(stats.revenue)}
                          </p>
                        </div>
                      </div>

                      <div className="desc">
                        <p className="desc-clamp">{product.description}</p>
                      </div>

                      {listCategories?.map((category) => (
                        <Fragment key={category.id}>
                          {category.id === product.category && (
                            <p className="category-product">{category.name}</p>
                          )}
                        </Fragment>
                      ))}

                      <FormOutlined
                        className="tool"
                        onClick={() =>
                          navigate(`/shop/${id}/products/${product.id}`)
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;